import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  TableRow,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ExpansionPanelActions
} from "@material-ui/core";
import DescriptiveRow from "../components/DescriptiveRow.jsx";
import DescriptiveCell from "../components/DescriptiveCell.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
//import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import { RemoveField } from "helpers/ReduxHelpers";
import _ from "lodash";
import React from "react";
import { change, Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import { NameOfBequeath } from "./objects/Conversion";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";

const required = value => (value ? undefined : "Required");
var incomeStreamExpander = true;

const CustomField = props => (
  <TableCell className="cellPaddingSmall">
    <FormControl fullWidth>
      <Field {...props} />
    </FormControl>
  </TableCell>
);

const CustomField2 = props => (
  <FormControl fullWidth style={{ bottom: "10px" }}>
    <Field {...props} />
  </FormControl>
);

const requiredDropdown = value => {
  if (!value || value === "validationError") {
    return "Required";
  }
  return undefined;
};

const percentage = value => {
  if (value === undefined) return undefined;

  if (isNaN(value)) {
    return "Must be a number";
  }

  if (parseInt(value, 10) >= 101 || parseInt(value, 10) < 0) {
    return "Not a valid Percentage";
  }
  return undefined;
};

const checkItem = (label, name, changeFunc) => {
  return (
    
            <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px"}}>
              <Field
                component={FormCheckbox}
                name={name}
                onChange={(e, f, g, h) => {
                  changeFunc(f, h)

                }}

              />
            </FormControl>
         
  );
};

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const need = value => {
  return (
    {
      category: "",
      incomeStream: "",
      disability: false,
      death: false,
      retirement: false,
      mounthlyAmount: 0,
      yearsPayable: 0,
      annualIncrease: 0,
      estateInherit: 0,
      spouseInherit: 0,
      dependentsInherit: 0,
      trustInherit: 0,
      otherInherit: 0,
      charityInherit: 0
    }
  )
}

class Conversion extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }



  addNewIncomeStream = () => {
    var needs = this.props.state.needs;
    var total = 0;
    needs.incomeStreams.push(need());
    needs.incomeStreams.map(e => {
        if(parseFloat(e.mounthlyAmount))
      if(parseFloat(e.mounthlyAmount.replace()))
      total += parseFloat(e.mounthlyAmount.replace())
    })
    this.props.state.needs.totals.incomeStreams = "R" + parseFloat(total)
    this.props.addNewNeed(needs);
  }

  addNewIncomeNeed = () => {
    var needs = this.props.state.needs;
    var total = 0;
    needs.incomeNeeds.push(need());
    needs.incomeNeeds.map(e => {
      if(e.mounthlyAmount)
      if(parseFloat(e.mounthlyAmount.replace()))
      total += parseFloat(e.mounthlyAmount.replace())
    })
    this.props.state.needs.totals.incomeNeeds = "R" + parseFloat(total)
    this.props.addNewNeed(needs);
  }

  addNewCapitalNeed = () => {
    var needs = this.props.state.needs;
    var total = 0;
    needs.capitalNeeds.push(need());
    needs.capitalNeeds.map(e => {
      if(e.mounthlyAmount)
      if(parseFloat(e.mounthlyAmount.replace()))
      total += parseFloat(e.mounthlyAmount.replace())
    })
    this.props.state.needs.totals.capitalNeeds = "R" + parseFloat(total)
    this.props.addNewNeed(needs);
  }

  addNewcashBequest = () => {
    var needs = this.props.state.needs;
    var total = 0;
    needs.cashBequests.push(need());
    needs.cashBequests.map(e => {
      if(e.mounthlyAmount)
      if(parseFloat(e.mounthlyAmount.replace()))
      total += parseFloat(e.mounthlyAmount.replace())
    })
    this.props.state.needs.totals.cashBequests = "R" + parseFloat(total)
    this.props.addNewNeed(needs);
  }

  
  remove = (n) => {
    var needs = this.props.state.needs;
    var newNeeds = [];
    var node = n.target;
    
    
    while(node.nodeName != "BUTTON" && node.parentNode != null)
    {
      node = node.parentNode
    }
    
    var i = node.name.replace("removeN", "").split(".")
    console.log(needs[i[0]])
    needs[i[0]].map((e,k) =>
    {
      console.log(JSON.stringify(needs[i[0]][i[1]]) + "-----------------------" + JSON.stringify(e))
      if(e != needs[i[0]][i[1]])
      newNeeds[k] = e
    })
    needs[i[0]] = newNeeds;
    var total = 0;
    needs[i[0]].map(e => {
      total += e.mounthlyAmount
    })
    needs.totals[i[0]] = "R" + parseFloat(total);
    
    this.props.addNewNeed(needs);
  }

  changeStream = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("provision", "").split(".")
    needs[need[0]][need[1]].incomeStream = value;
    this.props.changeNeed(needs);
  }

  changeCat = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("category", "").split(".")
    needs[need[0]][need[1]].category = value;
    this.props.changeNeed(needs);
  }

  changeDisability = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("disability", "").split(".")
    console.log(value)
    console.log(name)
    console.log(need)
    console.log(needs[need[0]])
    console.log(needs[need[0]][need[1]])
    needs[need[0]][need[1]].disability = value;
    this.props.changeNeed(needs);
  }

  changeDeath = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("death", "").split(".")
    needs[need[0]][need[1]].death = value;
    this.props.changeNeed(needs);
  }

  changeRetirement = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("retirement", "").split(".")
    needs[need[0]][need[1]].retirement = value;
    this.props.changeNeed(needs);
  }

  changeMounthlyAmount = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("mounthlyAmount", "").split(".")
    needs[need[0]][need[1]].mounthlyAmount = value;
    var total = 0;
    needs[need[0]].map(e => {
        if(e.mounthlyAmount)
      if(parseFloat(e.mounthlyAmount.replace()))
      total += parseFloat(e.mounthlyAmount.replace())
    })
    needs.totals[need[0]] = "R" + parseFloat(total);

    this.props.changeNeed(needs);
  }

  changeYearsPayable = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("yearsPayable", "").split(".")
    needs[need[0]][need[1]].yearsPayable = value;
    this.props.changeNeed(needs);
  }

  changeAnnualIncrease = (value, name) =>
  {
    var needs = this.props.state.needs;
    var need = name.replace("annualIncrease", "").split(".")
    needs[need[0]][need[1]].annualIncrease = value;
    this.props.changeNeed(needs);
  }




  IncomeNeedExpand = (expand) => {

    var needs = this.props.state.needs;
    console.log(expand.target)

    needs.expanded.incomeNeeds = !needs.expanded.incomeNeeds;
    this.props.changeNeedExpansion(needs);
  }

  IncomeStreamExpand = (expand) => {

    var needs = this.props.state.needs;
    console.log(expand.target)

    needs.expanded.incomeStreams = !needs.expanded.incomeStreams;
    this.props.changeNeedExpansion(needs);
    
  }

  CapitalNeedExpand = (expand) => {

    var needs = this.props.state.needs;
    console.log(expand.target)

    needs.expanded.capitalNeeds = !needs.expanded.capitalNeeds;
    this.props.changeNeedExpansion(needs);
   
  }


  cashBequestsExpand= (expand) => {

    var needs = this.props.state.needs;
    console.log(expand.target)

    needs.expanded.cashBequests = !needs.expanded.cashBequests;
    this.props.changeNeedExpansion(needs);
   
  }


  render() {
    let { checkValidation } = this.props;
    var needs = this.props.state.needs;
    needs.expanded.incomeNeeds = false;
    needs.expanded.incomeStreams = false;
    needs.expanded.capitalNeeds = false;
    needs.expanded.cashBequests = false;

    var clientD = "";
    if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname

    return (
      <div className="contentWithStepper" style={{ width: "120%", marginLeft: "-10%" }}>
        <Card >
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"Current Provision and Needs"}
            />


            <ExpansionPanel defaultExpanded={0 === 0} key={1} onClick={(event) => this.IncomeStreamExpand(event)} >
              <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("5em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Income Provision
                      </Typography>
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("2em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                         {this.props.state.needs.expanded.incomeStreams == false && "Total"}
                      </Typography>
                     
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("15em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        {this.props.state.needs.expanded.incomeStreams == false && this.props.state.needs.totals.incomeStreams}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                      
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("15em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Income Stream</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px' }}>
                          Death
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                            Disability
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Retirement</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Monthly Amount</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Years Receivable</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Annual Increase</Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>

                      {this.props.state.needs.incomeStreams.map((e, i) => {

                        return (
                          <TableRow>

                            <TableCell>
                          <Button
                            name={"incomeStreams.removeN" + i}
                            key = {"incomeStreams.removeN" + i}
                            variant="fab"
                            mini
                            className="tinyfab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>
                          <CustomField2
                              name={'incomeStreams.provision' + i}
                              component={FormInput}
                              checkValidation={this.props.checkValidation}
                              label={'description'}
                              isrequired={true}
                              //validate={[required]}
                              onChange={(e, value, t, name) => this.changeStream(value, name)}
                            />
                          
                          </TableCell>
                            
                        
                        
                        <TableCell>{checkItem("", "incomeStreams.death" + i, this.changeDeath)}</TableCell>
                        <TableCell>{checkItem("", "incomeStreams.disability" + i, this.changeDisability)}</TableCell>
                        <TableCell> {checkItem("", "incomeStreams.retirement" + i, this.changeRetirement)}</TableCell>

                             

                             

                            

                            

                            <CustomField
                              name={'incomeStreams.mounthlyAmount' + i}
                              prefix="R"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'R*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeMounthlyAmount(value, name)}
                            />

                            <CustomField
                              name={'incomeStreams.yearsPayable' + i}

                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'Years*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeYearsPayable(value, name)}
                            />

                            <CustomField
                              name={'incomeStreams.annualIncrease' + i}
                              suffix="%"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'%*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeAnnualIncrease(value, name)}
                            />




                          </TableRow>

                        )

                      })}

                      <TableRow>



                        <DescriptiveCell
                          width="150em"
                          description={"Add Income"}
                          add={() =>
                            this.addNewIncomeStream()
                          }


                        />


                        <TableCell><Typography variant="title"></Typography></TableCell>

                        <TableCell><Typography variant="title">
                          {/*this.props.state.needs.totals.incomeStreams*/}
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>


            <ExpansionPanel defaultExpanded={1 === 0} key={1} onClick={(event) => this.IncomeNeedExpand(event)} >
              <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("5em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Income Needs
                      </Typography>
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("2em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                         {this.props.state.needs.expanded.incomeNeeds == false && "Total"}
                      </Typography>
                     
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("15em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        {this.props.state.needs.expanded.incomeNeeds == false && this.props.state.needs.totals.incomeNeeds}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("15em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Income Stream</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px' }}>
                            Death
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                          Disability
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Retirement</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Monthly Amount</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Years Receivable</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Annual Increase</Typography>
                        </TableCell>


                      </TableRow>

                    </TableHead>
                    <TableBody>

                      {this.props.state.needs.incomeNeeds.map((e, i) => {

                        return (
                          <TableRow>

                            <TableCell>
                          <Button
                            name={"incomeNeeds.removeN" + i}
                            key = {"incomeNeeds.removeN" + i}
                            variant="fab"
                            mini
                            className="tinyfab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>
                          <CustomField2
                            name={'incomeNeeds.provision' + i}
                            component={FormInput}
                            checkValidation={this.props.checkValidation}
                            label={'description'}
                            isrequired={true}
                            //validate={[required]}
                            onChange={(e, value, t, name) => this.changeStream(value, name)}
                            
                            
                          />
                        </TableCell>

                            

                          
                          <TableCell>{checkItem("", "incomeNeeds.death" + i, this.changeDeath)}</TableCell>
                          <TableCell>{checkItem("", "incomeNeeds.disability" + i, this.changeDisability)}</TableCell>
                          <TableCell> {checkItem("", "incomeNeeds.retirement" + i, this.changeRetirement)}</TableCell>

                            <CustomField
                              name={'incomeNeeds.mounthlyAmount' + i}
                              prefix="R"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'R*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeMounthlyAmount(value, name)}
                            />

                            <CustomField
                              name={'incomeNeeds.yearsPayable' + i}

                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'Years*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeYearsPayable(value, name)}
                            />

                            <CustomField
                              name={'incomeNeeds.annualIncrease' + i}
                              suffix="%"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'%*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeAnnualIncrease(value, name)}
                            />




                          </TableRow>

                        )

                      })}

                      <TableRow>



                        <DescriptiveCell
                          width="150em"
                          description={"Add Income"}
                          add={() =>
                            this.addNewIncomeNeed()
                          }


                        />


                        <TableCell><Typography variant="title"></Typography></TableCell>

                        <TableCell><Typography variant="title">
                          {/*this.props.state.needs.totals.incomeNeeds*/}
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>


            <ExpansionPanel defaultExpanded={1 === 0} key={1} onClick={(event) => this.CapitalNeedExpand(event)} >
              <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("5em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Lumpsum Capital Needs
                      </Typography>
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("2em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                         {this.props.state.needs.expanded.capitalNeeds == false && "Total"}
                      </Typography>
                     
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("15em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        {this.props.state.needs.expanded.capitalNeeds == false && this.props.state.needs.totals.capitalNeeds}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                      <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("15em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Category</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("8.5em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Description</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px' }}>
                          Death
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                          Disability
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Retirement</Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Amount</Typography>
                        </TableCell>

                       


                      </TableRow>

                    </TableHead>
                    <TableBody>

                      {this.props.state.needs.capitalNeeds.map((e, i) => {

                        return (
                          <TableRow>

                            <TableCell>
                          <Button
                            name={"capitalNeeds.removeN" + i}
                            key = {"capitalNeeds.removeN" + i}
                            variant="fab"
                            mini
                            className="tinyfab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>
                          
                           <CustomField2
                            name={"capitalNeeds.category" + i}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={''}
                            isrequired={true}
                            
                            //validate={[required]}
                            options=
                            {
                              [  {
                                  displayValue: "Please Select",
                                  value: " ",
                                  limit: 1
                              },
                              {
                                  displayValue: "Education",
                                  value: "education"
                              },
                              {
                                  displayValue: "Fixed asset",
                                  value: "fixedAsset"
                              },
                              {
                                  displayValue: "Other asset",
                                  value: "otherAsset"
                              },
                              {
                                  displayValue: "Other",
                                  value: "other"
                              }]
                            }
                            onChange={(e, value, t, name) => this.changeCat(value, name)}
                            
                            
                          />
                        </TableCell>
                            <TableCell>
                            <CustomField
                            name={'capitalNeeds.provision' + i}
                            component={FormInput}
                            checkValidation={this.props.checkValidation}
                            label={'description'}
                            isrequired={true}
                            //validate={[required]}
                            onChange={(e, value, t, name) => this.changeStream(value, name)}
                            
                            
                          />
                            </TableCell>
                           

                            
                            <TableCell>{checkItem("", "capitalNeeds.death" + i, this.changeDeath)}</TableCell>
                            <TableCell>{checkItem("", "capitalNeeds.disability" + i, this.changeDisability)}</TableCell>
                            <TableCell> {checkItem("", "capitalNeeds.retirement" + i, this.changeRetirement)}</TableCell>

                            <CustomField
                              name={'capitalNeeds.mounthlyAmount' + i}
                              prefix="R"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'R*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeMounthlyAmount(value, name)}
                            />

                          </TableRow>

                        )

                      })}

                      <TableRow>



                        <DescriptiveCell
                          width="150em"
                          description={"Add Income"}
                          add={() =>
                            this.addNewCapitalNeed()
                          }


                        />


                        <TableCell><Typography variant="title"></Typography></TableCell>

                        <TableCell><Typography variant="title">
                          {/*this.props.state.needs.totals.capitalNeeds*/}
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>


            <ExpansionPanel defaultExpanded={1 === 0} key={1} onClick={(event) => this.cashBequestsExpand(event)} >
              <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>} >
                <Table>
                  <TableRow>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("5em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        Cash Bequests
                      </Typography>
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("2em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                         {this.props.state.needs.expanded.cashBequests == false && "Total"}
                      </Typography>
                     
                    </TableCell>
                    <TableCell
                      className="cellPaddingTiny"
                      style={colwidth("15em")}
                    >
                      <Typography
                        variant="title"
                        style={{ fontWeight: 'bold' }}
                      >
                        {this.props.state.needs.expanded.cashBequests == false && this.props.state.needs.totals.cashBequests}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </Table>

              </ExpansionPanelSummary>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
                <Grid container spacing={24} >
                  <Table className="customTable1">
                    <TableHead className="fixedHead">
                      <TableRow>
                      <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("15em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Category</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("8.5em")}

                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Description</Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}

                        >
                          <Typography style={{ fontSize: '16px' }}>
                            
                          </Typography>

                        </TableCell>
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}


                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center", verticalAlign: 'bottom' }}>
                            
                          </Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}></Typography>
                        </TableCell>

                        <TableCell
                          className="cellPaddingSmall"
                          style={colwidth("12em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Amount</Typography>
                        </TableCell>

                       


                      </TableRow>

                    </TableHead>
                    <TableBody>

                      {this.props.state.needs.cashBequests.map((e, i) => {

                        return (
                          <TableRow>

                            <TableCell>
                          <Button
                            name={"cashBequests.removeN" + i}
                            key = {"cashBequests.removeN" + i}
                            variant="fab"
                            mini
                            className="tinyfab"
                            color="primary"
                            style={{ left: "-20px", top: "-5px" }}
                            onClick={(e) =>{e.stopPropagation(); this.remove(e)}}
                          >
                            <Icon style={{ color: "white" }}>remove</Icon>
                          </Button>
                          
                           <CustomField2
                            name={"cashBequests.category" + i}
                            component={FormDropdown}
                            checkValidation={this.props.checkValidation}
                            label={''}
                            isrequired={true}
                            
                            //validate={[required]}
                            options=
                            {
                              [  {
                                  displayValue: "Please Select",
                                  value: " ",
                                  limit: 1
                              },
                              {
                                  displayValue: "Cash bequest",
                                  value: "cashBequest"
                              },
                              {
                                  displayValue: "Cash bequest to charity",
                                  value: "cashBequestCharity"
                              }
                              ]
                            }
                            onChange={(e, value, t, name) => this.changeCat(value, name)}
                            
                            
                          />
                        </TableCell>
                            <TableCell>
                            <CustomField
                            name={'cashBequests.provision' + i}
                            component={FormInput}
                            checkValidation={this.props.checkValidation}
                            label={'description'}
                            isrequired={true}
                            //validate={[required]}
                            onChange={(e, value, t, name) => this.changeStream(value, name)}
                            
                            
                          />
                            </TableCell>
                           

                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>

                            <CustomField
                              name={'cashBequests.mounthlyAmount' + i}
                              prefix="R"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'R*'}
                              isrequired={true}
                              validate={[required]}
                              onChange={(e, value, t, name) => this.changeMounthlyAmount(value, name)}
                            />

                          </TableRow>

                        )

                      })}

                      <TableRow>



                        <DescriptiveCell
                          width="150em"
                          description={"Add Bequest"}
                          add={() =>
                            this.addNewcashBequest()
                          }


                        />


                        
                        <TableCell><Typography variant="title">
                         
                          
                        </Typography></TableCell>


                      </TableRow>

                    </TableBody>
                  </Table>

                </Grid>

              </ExpansionPanelDetails>

            </ExpansionPanel>

          </CardContent>
        </Card>
      </div>
    );
  }
}

export default Conversion;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/Conversion.jsx